import React from 'react';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _cloneDeep from 'lodash/cloneDeep';

import { FeatureUpsell, Config, UiKit } from 'components';
import RuleConfiguration from './RuleConfiguration';
import { useRecommendationConfig } from '../hooks';
import { createRuleConfig } from '../methods';

export default function RecommendationRule() {
  const {
    data,
    ruleOptions,
    isProcessing,
    updateData,
    clearErrors
  } = useRecommendationConfig();

  const rule = _get(data, 'rule', null);
  const configData = _get(data, 'config', []);
  const configElements = _get(rule, 'config', []);
  const isDisabled = _get(rule, 'isDisabled', false);

  const onConfigChange = (id, value) => {
    if (isProcessing) return;
    const config = _cloneDeep(configData);
    _set(config, id, value);
    updateData({ config });
    clearErrors(`config.${id}`);
  };

  const onRuleChange = rule => {
    if (isProcessing || isDisabled) return;
    const configs = _get(rule, 'config', []);
    updateData({ rule, config: createRuleConfig(configs) });
    clearErrors('config');
  };

  return (
    <Config.Section
      description={
        <>
          Select a recommendation rule from pre-defined options.
          <FeatureUpsell.Banner
            compact
            className="mt-3"
            featureSlug="EXCHANGE_RECOMMENDATIONS_PRO"
          />
        </>
      }
    >
      <UiKit.Select
        label="Recommendation set rule"
        options={ruleOptions}
        value={rule}
        onChange={onRuleChange}
        isDisabled={isProcessing}
      />
      <RuleConfiguration
        configData={configData}
        configElements={configElements}
        onChange={onConfigChange}
      />
    </Config.Section>
  );
}
